(function(){
"use strict";

// ── STATE ────────────────────────────────────────────────────────────────────
var zoom=14, size=4, sizeMin=2, sizeMax=12, detail='med';
var arcSz=[0,8,24,8.5];
var mapLoaded=false, isLoading=false, fetchTimer=null;
var fetchingRoads=false, fetchErrorUntil=0, fetchQueued=false;
// Three independent caches, fetched progressively so something useful
// (water + major roads) appears fast even in dense cities, while
// residential/service streets (the slow part) load in afterward.
//  W = water/coastline/rivers — sparse everywhere, pad=0.5
//  M = major roads (LOW_HW)   — small, pad=0.35
//  D = residential/service/etc, only when detail!=='low' — pad=0.15
var fetchedBoundsW=null, fetchedBoundsM=null, fetchedBoundsD=null;
var ovElementsW=[], ovElementsM=[], ovElementsD=[];
var lMap=null, waterLayer=null, roadLayer=null, heartMarker=null;
var mapCenter=null, mapLabel='';
var zoomValEl=document.getElementById('zoomVal')||{textContent:''};

// ── HELPERS ──────────────────────────────────────────────────────────────────
function setStatus(cls,msg){var e=document.getElementById('mapStatus');e.className='map-status'+(cls?' '+cls:'');e.textContent=msg;}
function getUnit(){var e=document.querySelector('[data-group="unit"].on');return e?e.dataset.val:'in';}
function fmtZoom(z){return Number.isInteger(z)?String(z):z.toFixed(1);}
function updateDimHint(){
  var u=getUnit(),dh=document.getElementById('dimHint');
  if(dh) dh.textContent=(u==='in'?'\u2248 '+(size*25.4).toFixed(1)+' mm':'\u2248 '+(size/25.4).toFixed(2)+' in')+' export size';
  var sv=document.getElementById('sizeVal');
  if(sv){if(sv.tagName==='INPUT')sv.value=size;else sv.textContent=size;}
}
function xmlEsc(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function showLoading(on){var el=document.getElementById('mapLoading');if(el)el.style.display=on?'block':'none';}

// ── ROAD WEIGHT TABLE ────────────────────────────────────────────────────────
var WEIGHTS={motorway:7,trunk:5.5,primary:4.5,secondary:3,tertiary:2,
             residential:1.4,unclassified:1.4,living_street:1.1,
             service:0.8,pedestrian:0.8,busway:0.8};
var LOW_HW =['motorway','trunk','primary','secondary','tertiary'];
var MED_HW =LOW_HW.concat(['residential','unclassified','living_street']);
var HIGH_HW=MED_HW.concat(['service','pedestrian','busway']);
function getAllowedHW(){return detail==='low'?LOW_HW:detail==='med'?MED_HW:HIGH_HW;}

// ── LEAFLET MAP ──────────────────────────────────────────────────────────────
function initLeaflet(){
  if(lMap) return;
  lMap=L.map('leafletMap',{
    zoomControl:false,attributionControl:true,
    scrollWheelZoom:true,doubleClickZoom:true,
    zoomSnap:0.5,zoomDelta:0.5,
    fadeAnimation:false
  });
  lMap.createPane('waterPane');
  lMap.getPane('waterPane').style.zIndex=350; // below default overlayPane (400)
  waterLayer=L.layerGroup().addTo(lMap);
  roadLayer=L.layerGroup().addTo(lMap);
  lMap.on('zoomend',function(){
    zoom=Math.round(lMap.getZoom()*2)/2;
    zoom=Math.max(7,Math.min(19,zoom));
    document.getElementById('zoomSlider').value=zoom;
    zoomValEl.textContent=fmtZoom(zoom);
  });
  lMap.on('zoomend',function(){
    clearTimeout(fetchTimer);
    if(mapLoaded) fetchTimer=setTimeout(fetchRoads,500);
  });
  lMap.on('moveend',function(){
    clearTimeout(fetchTimer);
    if(mapLoaded) fetchTimer=setTimeout(fetchRoads,500);
  });
}

function buildPinIcon(type){
  var paths={
    heart:'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
    pin:'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    house:'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
  };
  var d=paths[type]||paths.heart;
  return L.divIcon({
    html:'<svg viewBox="0 0 24 24" width="56" height="56"><path fill="#cc2200" d="'+d+'"/></svg>',
    className:'',iconSize:[56,56],iconAnchor:[28,28]
  });
}

// ── STITCH COASTLINE SEGMENTS ────────────────────────────────────────────────
// Works with arrays of [lat,lon] or [x,y] – generic 2-element arrays
function stitchChains(segments,EPS){
  if(EPS===undefined) EPS=0.0002;
  var chains=segments.map(function(s){return s.slice();});
  function dist(a,b){return Math.abs(a[0]-b[0])+Math.abs(a[1]-b[1]);}
  var changed=true;
  while(changed){
    changed=false;
    outer:for(var i=0;i<chains.length;i++){
      for(var j=i+1;j<chains.length;j++){
        var a=chains[i],b=chains[j];
        var a0=a[0],aE=a[a.length-1],b0=b[0],bE=b[b.length-1];
        if(dist(aE,b0)<EPS){chains[i]=a.concat(b.slice(1));chains.splice(j,1);changed=true;break outer;}
        if(dist(bE,a0)<EPS){chains[i]=b.concat(a.slice(1));chains.splice(j,1);changed=true;break outer;}
        if(dist(aE,bE)<EPS){chains[i]=a.concat(b.slice().reverse().slice(1));chains.splice(j,1);changed=true;break outer;}
        if(dist(a0,b0)<EPS){chains[i]=a.slice().reverse().concat(b.slice(1));chains.splice(j,1);changed=true;break outer;}
      }
    }
  }
  return chains;
}
// Stitch [lat,lon] arrays (coastlines/relations)
function stitchCoastlines(segments){return stitchChains(segments,0.0002);}
// Stitch {x,y} object arrays (mm coords for SVG export)
function stitchMmPaths(segs){
  var EPS=0.01; // 0.01mm tolerance
  var chains=segs.map(function(s){return s.slice();});
  function D(p,q){return Math.abs(p.x-q.x)+Math.abs(p.y-q.y);}
  var changed=true;
  while(changed){
    changed=false;
    outer:for(var i=0;i<chains.length;i++){
      for(var j=i+1;j<chains.length;j++){
        var a=chains[i],b=chains[j];
        if(D(a[a.length-1],b[0])<EPS){chains[i]=a.concat(b.slice(1));chains.splice(j,1);changed=true;break outer;}
        if(D(b[b.length-1],a[0])<EPS){chains[i]=b.concat(a.slice(1));chains.splice(j,1);changed=true;break outer;}
        if(D(a[a.length-1],b[b.length-1])<EPS){chains[i]=a.concat(b.slice().reverse().slice(1));chains.splice(j,1);changed=true;break outer;}
        if(D(a[0],b[0])<EPS){chains[i]=a.slice().reverse().concat(b.slice(1));chains.splice(j,1);changed=true;break outer;}
      }
    }
  }
  return chains;
}

// ── CLIP POLYLINE TO BBOX ────────────────────────────────────────────────────
// Overpass returns FULL OSM way geometry; coastlines extend far beyond viewport.
// This clips chains so endpoints lie exactly on the bbox boundary for bboxPos().
function clipToBox(pts,N,S,W,E){
  var EPS=0.00001,out=[],cur=null;
  function inB(p){return p[0]>=S-EPS&&p[0]<=N+EPS&&p[1]>=W-EPS&&p[1]<=E+EPS;}
  function lerp(a,b,t){return[a[0]+t*(b[0]-a[0]),a[1]+t*(b[1]-a[1])];}
  function snap(p){
    var lat=p[0],lon=p[1];
    if(Math.abs(lat-N)<2e-4)lat=N;else if(Math.abs(lat-S)<2e-4)lat=S;
    if(Math.abs(lon-W)<2e-4)lon=W;else if(Math.abs(lon-E)<2e-4)lon=E;
    return[lat,lon];
  }
  function ts(a,b){
    var dlat=b[0]-a[0],dlon=b[1]-a[1],r=[];
    function t(v){if(v>=-EPS&&v<=1+EPS)r.push(Math.min(1,Math.max(0,v)));}
    if(Math.abs(dlat)>1e-12){t((N-a[0])/dlat);t((S-a[0])/dlat);}
    if(Math.abs(dlon)>1e-12){t((E-a[1])/dlon);t((W-a[1])/dlon);}
    r.sort(function(a,b){return a-b;});
    var u=[];r.forEach(function(v){if(!u.length||v-u[u.length-1]>EPS)u.push(v);});
    return u;
  }
  for(var i=0;i<pts.length-1;i++){
    var a=pts[i],b=pts[i+1],iA=inB(a),iB=inB(b);
    if(iA&&iB){if(!cur)cur=[snap(a)];cur.push(snap(b));}
    else if(iA){
      // a is inside, b is outside: exit point is the FIRST (smallest)
      // crossing parameter -- ts() returns sorted-ascending values, and
      // since a is inside, everything before tv[0] is still inside.
      var tv=ts(a,b),x=tv.length?tv[0]:1;
      if(!cur)cur=[snap(a)];cur.push(snap(lerp(a,b,x)));
      if(cur.length>=2)out.push(cur);cur=null;
    }else if(iB){
      // a is outside, b is inside: entry point is the LAST (largest)
      // crossing parameter -- everything after it, including b, is inside.
      var tv=ts(a,b),x=tv.length?tv[tv.length-1]:0;
      cur=[snap(lerp(a,b,x)),snap(b)];
    }else{
      if(cur){if(cur.length>=2)out.push(cur);cur=null;}
      var tv=ts(a,b),ins=tv.filter(function(t){return inB(lerp(a,b,t));});
      if(ins.length>=2)out.push([snap(lerp(a,b,ins[0])),snap(lerp(a,b,ins[ins.length-1]))]);
    }
  }
  if(cur&&cur.length>=2)out.push(cur);
  return out;
}

// ── OCEAN POLYGON VIA CW BBOX CLOSURE ────────────────────────────────────────
// OSM coastline: land=LEFT, sea=RIGHT when traversing.
// Clockwise bbox closure from chain[end]→chain[start] = sea interior.
// Verified correct for all orientations: N/S/E/W-facing coasts.
function makeOceanPolygons(chains,bounds){
  var N=bounds.N,S=bounds.S,W=bounds.W,E=bounds.E,eps=0.001;
  var cwC=[[N,W],[N,E],[S,E],[S,W]]; // NW=0,NE=1,SE=2,SW=3
  function bboxPos(ll){
    var la=ll[0],lo=ll[1];
    if(Math.abs(la-N)<eps)return (lo-W)/(E-W);
    if(Math.abs(lo-E)<eps)return 1+(N-la)/(N-S);
    if(Math.abs(la-S)<eps)return 2+(E-lo)/(E-W);
    if(Math.abs(lo-W)<eps)return 3+(la-S)/(N-S);
    return -1;
  }
  var res=[];
  chains.forEach(function(chain){
    if(chain.length<2)return;
    var pS=bboxPos(chain[0]),pE=bboxPos(chain[chain.length-1]);
    if(pS<0||pE<0)return;
    var poly=chain.slice();
    var cwD=pS-pE;if(cwD<=0)cwD+=4;
    var c=Math.ceil(pE)%4;
    if(Math.abs(pE-c)<0.0001)c=(c+1)%4;
    for(var i=0;i<4;i++){
      var d=c-pE;if(d<=0)d+=4;
      if(d>=cwD)break;
      poly.push(cwC[c]);c=(c+1)%4;
    }
    res.push(poly);
  });
  return res;
}

// Shoelace area of a [lat,lon] polygon as a fraction of the bbox's degree-area.
// Used to detect the 'both riverbanks tagged as coastline' signature: two
// CW-closure polygons that are near-complementary halves of the bbox.
function polygonAreaRatio(poly,bounds){
  var a=0;
  for(var i=0;i<poly.length;i++){
    var p1=poly[i],p2=poly[(i+1)%poly.length];
    a+=p1[1]*p2[0]-p2[1]*p1[0];
  }
  a=Math.abs(a)/2;
  var bb=(bounds.N-bounds.S)*(bounds.E-bounds.W);
  return bb>0?a/bb:0;
}

// ── RENDER ROADS (LEAFLET PREVIEW) ───────────────────────────────────────────
function renderRoads(){
  waterLayer.clearLayers();
  roadLayer.clearLayers();
  var allowed=getAllowedHW();
  var coastSegs=[];
  var relationChains=[];
  var els=ovElementsW.concat(ovElementsM,ovElementsD);
  els.forEach(function(el){
    if(el.type==='relation'){
      var outerSegs=[];
      (el.members||[]).forEach(function(m){
        if(m.geometry&&m.geometry.length>=2&&m.role!=='inner')
          outerSegs.push(m.geometry.map(function(p){return[p.lat,p.lon];}));
      });
      stitchCoastlines(outerSegs).forEach(function(chain){
        if(chain.length>=3)relationChains.push(chain);
      });
      return;
    }
    if(!el.geometry||el.geometry.length<2) return;
    var t=el.tags||{};
    var lls=el.geometry.map(function(p){return[p.lat,p.lon];});
    if(t.waterway==='river'||t.waterway==='canal'){
      L.polyline(lls,{pane:'waterPane',color:'#7ec8e3',weight:5,opacity:.85,lineCap:'round',lineJoin:'round'}).addTo(waterLayer);
    } else if(t.natural==='water'){
      var f=lls[0],la=lls[lls.length-1];
      if(Math.abs(f[0]-la[0])<0.00003&&Math.abs(f[1]-la[1])<0.00003)
        L.polygon(lls,{pane:'waterPane',color:'none',weight:0,fillColor:'#7ec8e3',fillOpacity:0.9}).addTo(waterLayer);
    } else if(t.natural==='coastline'){
      coastSegs.push(lls);
    } else if(t.highway&&allowed.indexOf(t.highway)!==-1){
      var w=WEIGHTS[t.highway]||1;
      L.polyline(lls,{color:'#000',weight:w,opacity:1,lineCap:'round',lineJoin:'round'}).addTo(roadLayer);
    }
  });

  // ── COASTLINE → OCEAN FILL (CW-closure) ──────────────────────────────
  // No ambiguity check: waterPane z-ordering (z=350, below roads at 400)
  // ensures roads are always visible above water regardless of fill area.
  if(coastSegs.length&&fetchedBoundsW){
    var fb=fetchedBoundsW;
    var stitched=stitchCoastlines(coastSegs);
    var clippedCoast=[];
    stitched.forEach(function(chain){
      clipToBox(chain,fb.N,fb.S,fb.W,fb.E).forEach(function(c){clippedCoast.push(c);});
    });
    var oceanPolys=makeOceanPolygons(clippedCoast,fb);
    var centerLL=mapCenter?[mapCenter.lat,mapCenter.lon]:[0,0];
    oceanPolys.forEach(function(poly){
      if(mapCenter&&pointInPoly(centerLL,poly)){
        // Polygon covers LAND (contains the address) →
        // set map bg to water, fill this polygon with land color
        document.getElementById('leafletMap').style.background='#7ec8e3';
        L.polygon(poly,{pane:'waterPane',color:'none',weight:0,fillColor:'#d4c3a7',fillOpacity:1}).addTo(waterLayer);
      }else{
        // Polygon covers WATER → fill with water color
        L.polygon(poly,{pane:'waterPane',color:'none',weight:0,fillColor:'#7ec8e3',fillOpacity:0.9}).addTo(waterLayer);
      }
    });
  }

  // Relation-derived water: closed chains fill, open as lines
  relationChains.forEach(function(chain){
    var f0=chain[0],l0=chain[chain.length-1];
    var closed=Math.abs(f0[0]-l0[0])<3e-4&&Math.abs(f0[1]-l0[1])<3e-4;
    if(closed){
      L.polygon(chain,{pane:'waterPane',color:'none',weight:0,fillColor:'#7ec8e3',fillOpacity:0.9}).addTo(waterLayer);
    }else{
      L.polyline(chain,{pane:'waterPane',color:'#7ec8e3',weight:5,opacity:.85,lineCap:'round',lineJoin:'round'}).addTo(waterLayer);
    }
  });
}

// ── OVERPASS HELPER \u2014 tries mirrors, returns elements array or throws ─────────
async function overpassQuery(q,timeoutMs,_retry){
  var mirrors=['https://overpass-api.de/api/interpreter','https://overpass.kumi.systems/api/interpreter'];
  var lastErr='';
  for(var i=0;i<mirrors.length;i++){
    var ctrl=new AbortController();
    var tid=setTimeout(function(){ctrl.abort();},timeoutMs);
    try{
      var r=await fetch(mirrors[i],{method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded'},
        body:'data='+encodeURIComponent(q),signal:ctrl.signal});
      clearTimeout(tid);
      if(r.status===429){lastErr='Rate limited';await new Promise(function(res){setTimeout(res,1200);});continue;}
      if(!r.ok){lastErr='HTTP '+r.status;continue;}
      var j=await r.json();
      return j.elements||[];
    }catch(e){
      clearTimeout(tid);
      lastErr=e.name==='AbortError'?'timeout':e.message;
    }
  }
// Auto-retry once on failure (covers transient Overpass hiccups)
  if(!_retry){
    await new Promise(function(r){setTimeout(r,2000);});
    return overpassQuery(q,timeoutMs,true);
  }
  throw new Error(lastErr);
}

function bboxStr(b,pad){
  var dH=b.getNorth()-b.getSouth(),dW=b.getEast()-b.getWest();
  return{
    S:(b.getSouth()-pad*dH).toFixed(5), N:(b.getNorth()+pad*dH).toFixed(5),
    W:(b.getWest() -pad*dW).toFixed(5), E:(b.getEast() +pad*dW).toFixed(5)
  };
}
function inBounds(fb,b){
  return fb&&b.getSouth()>=fb.S&&b.getNorth()<=fb.N&&b.getWest()>=fb.W&&b.getEast()<=fb.E;
}

// ── PERSISTENT CACHE (localStorage) ────────────────────────────────────────
// Survives page refresh, so re-testing the same/nearby address (the normal
// workflow while tuning an ornament) is instant on the 2nd+ load. Pure
// read-through cache of the exact same Overpass data -- no effect on
// correctness, only on whether a network round-trip is needed. Every
// operation is try/catch'd: if localStorage is unavailable (some file://
// contexts), this silently does nothing and behavior is unchanged.
var CACHE_KEY='mapOrnamentCacheV7';
var persistCache={W:[],M:[],D:[]};
(function(){
  try{
    var raw=localStorage.getItem(CACHE_KEY);
    if(raw){
      var c=JSON.parse(raw);
      if(c&&Array.isArray(c.W))persistCache.W=c.W;
      if(c&&Array.isArray(c.M))persistCache.M=c.M;
      if(c&&Array.isArray(c.D))persistCache.D=c.D;
    }
  }catch(e){}
})();
function findCached(tier,b){
  var arr=persistCache[tier]||[];
  for(var i=0;i<arr.length;i++){
    if(inBounds(arr[i].bounds,b))return arr[i];
  }
  return null;
}
function saveToCache(tier,bounds,els,maxEntries,maxBytes){
  try{
    if(!els||!els.length)return; // don't persist empty/suspicious results
    var entry={bounds:bounds,els:els};
    var json=JSON.stringify(entry);
    if(json.length>maxBytes)return; // too big for this tier, skip silently
    var arr=persistCache[tier];
    arr.unshift(entry);
    while(arr.length>maxEntries)arr.pop();
    try{
      localStorage.setItem(CACHE_KEY,JSON.stringify(persistCache));
    }catch(e){
      // Likely quota exceeded -- drop to just this newest entry and retry once
      persistCache[tier]=[entry];
      try{localStorage.setItem(CACHE_KEY,JSON.stringify(persistCache));}catch(e2){}
    }
  }catch(e){}
}
function boundsFromBox(box){
  return{N:parseFloat(box.N),S:parseFloat(box.S),W:parseFloat(box.W),E:parseFloat(box.E)};
}

// ── FETCH ROADS — sequential three-tier progressive ──────────────────────────
// Each tier is fetched ONE AT A TIME (sequential, never parallel) to stay
// within Overpass's per-IP concurrency limit. After each tier completes,
// renderRoads() runs immediately so the user sees progressive improvement.
//  W = water/coastline/rivers only (sparse, fast everywhere) — pad=0.5
//  M = major roads only (LOW_HW, small query) — pad=0.35
//  D = residential/service/etc — pad=0.15, only when detail!=='low'
async function fetchRoads(){
  if(!lMap||!mapLoaded) return;
  if(fetchingRoads){fetchQueued=true;return;}
  if(Date.now()<fetchErrorUntil) return;
  var z=lMap.getZoom();
  if(!z||z<10){setStatus('','Zoom in more to load streets (min zoom 10)');return;}
  var b;
  try{b=lMap.getBounds();}catch(e){return;}

  var needW=!inBounds(fetchedBoundsW,b);
  var needM=!inBounds(fetchedBoundsM,b);
  var needD=(detail!=='low')&&!inBounds(fetchedBoundsD,b);
  // Persistent-cache fallback
  if(needW){var cW=findCached('W',b);if(cW){ovElementsW=cW.els;fetchedBoundsW=cW.bounds;needW=false;}}
  if(needM){var cM=findCached('M',b);if(cM){ovElementsM=cM.els;fetchedBoundsM=cM.bounds;needM=false;}}
  if(needD){var cD=findCached('D',b);if(cD){ovElementsD=cD.els;fetchedBoundsD=cD.bounds;needD=false;}}
  if(!needW&&!needM&&!needD){ renderRoads(); setStatus('ok','\u2713 '+mapLabel); return; }

  fetchingRoads=true;fetchQueued=false;
  showLoading(true);
  var anyErr=false,lastErr='';
  try{

  // ── Phase 1: water only (sparse, fast even in NYC) ───────────────────────
  if(needW){
    setStatus('','Loading water\u2026');
    var boxW=bboxStr(b,0.5);
    var qW='[out:json][timeout:10][maxsize:1000000];('+
      'way[\"natural\"~\"water|coastline\"]('+boxW.S+','+boxW.W+','+boxW.N+','+boxW.E+');'+
      'way[\"waterway\"~\"river|stream|canal\"]('+boxW.S+','+boxW.W+','+boxW.N+','+boxW.E+');'+
      'relation[\"natural\"=\"water\"]('+boxW.S+','+boxW.W+','+boxW.N+','+boxW.E+');'+
      ');out geom qt;';
    try{
      ovElementsW=await overpassQuery(qW,8000);
      fetchedBoundsW=boundsFromBox(boxW);
      saveToCache('W',fetchedBoundsW,ovElementsW,5,800000);
      renderRoads();
    }catch(e){anyErr=true;lastErr=e.message;}
  }

  // ── Phase 2: major roads only (separate small query) ─────────────────────
  if(needM){
    setStatus('','Loading roads\u2026');
    var boxM=bboxStr(b,0.35);
    var qM='[out:json][timeout:12][maxsize:1500000];('+
      'way[\"highway\"~\"'+LOW_HW.join('|')+'\"]('+boxM.S+','+boxM.W+','+boxM.N+','+boxM.E+');'+
      ');out geom qt;';
    try{
      ovElementsM=await overpassQuery(qM,10000);
      fetchedBoundsM=boundsFromBox(boxM);
      saveToCache('M',fetchedBoundsM,ovElementsM,5,800000);
      renderRoads();
    }catch(e){anyErr=true;lastErr=e.message;}
  }

  // ── Phase 3: detail roads (only when detail!=='low') ─────────────────────
  if(needD){
    setStatus('','Loading street detail\u2026');
    var boxD=bboxStr(b,0.15);
    var extraHW=HIGH_HW.filter(function(h){return LOW_HW.indexOf(h)===-1;}).join('|');
    var qD='[out:json][timeout:15][maxsize:1500000];('+
      'way[\"highway\"~\"'+extraHW+'\"]('+boxD.S+','+boxD.W+','+boxD.N+','+boxD.E+');'+
      ');out geom qt;';
    try{
      ovElementsD=await overpassQuery(qD,12000);
      fetchedBoundsD=boundsFromBox(boxD);
      saveToCache('D',fetchedBoundsD,ovElementsD,2,1500000);
      renderRoads();
    }catch(e){anyErr=true;lastErr=e.message;}
  }

  showLoading(false);
  if(anyErr){
    setStatus('err','Some data timed out \u2014 tap here to retry');
    fetchErrorUntil=Date.now()+1500;
    document.getElementById('mapStatus').style.cursor='pointer';
    document.getElementById('mapStatus').onclick=function(){this.onclick=null;this.style.cursor='';fetchRoads();};
  }else{
    var total=ovElementsW.length+ovElementsM.length+ovElementsD.length;
    setStatus('ok','\u2713 '+mapLabel+(total?'':' \u2014 no roads'));
  }
  }catch(e){
    showLoading(false);
    setStatus('err','Map error \u2014 tap here to retry');
    fetchErrorUntil=Date.now()+1500;
    document.getElementById('mapStatus').style.cursor='pointer';
    document.getElementById('mapStatus').onclick=function(){this.onclick=null;this.style.cursor='';fetchRoads();};
  }finally{
    fetchingRoads=false;
    if(fetchQueued){fetchQueued=false;setTimeout(fetchRoads,50);}
  }
}

// ── GEOCODE & LOAD MAP ───────────────────────────────────────────────────────
async function loadMap(){
  var addr=document.getElementById('addressInput').value.trim();
  if(!addr||isLoading) return;
  isLoading=true;
  var btn=document.getElementById('fetchBtn');
  btn.disabled=true;btn.textContent='Loading\u2026';
  setStatus('','Geocoding\u2026');
  try{
    // Strip unit/suite/apt numbers (#105, Suite 200, etc.) — they confuse
    // Nominatim but don't affect geographic coordinates.
    var cleanAddr=addr.replace(/\s*#\s*\d+[A-Za-z]*/g,'').replace(/\s*\b(Suite|Ste|Apt|Unit|Fl|Floor)\s*\.?\s*\d+[A-Za-z]*/gi,'').replace(/\s{2,}/g,' ').trim();
    var res=await fetch('https://nominatim.openstreetmap.org/search?format=geojson&limit=1&q='+encodeURIComponent(cleanAddr),{headers:{'Accept-Language':'en'}});
    if(!res.ok) throw new Error('Geocoding failed ('+res.status+')');
    var data=await res.json();
    if(!data.features||!data.features.length){setStatus('err','Address not found \u2014 try adding a city or country.');return;}
    var cLon=data.features[0].geometry.coordinates[0];
    var cLat=data.features[0].geometry.coordinates[1];
    mapLabel=((data.features[0].properties&&data.features[0].properties.display_name)||addr).split(',').slice(0,2).join(',');
    mapCenter={lat:cLat,lon:cLon};
    lMap.invalidateSize(); // canvas renderer may have been sized before layout settled
    lMap.setView([cLat,cLon],zoom);
    var pinType=(document.querySelector('.pin-btn.on')||{dataset:{pin:'heart'}}).dataset.pin;
    if(heartMarker) heartMarker.remove();
    heartMarker=L.marker([cLat,cLon],{icon:buildPinIcon(pinType),zIndexOffset:1000}).addTo(lMap);
    document.getElementById('noMapPlaceholder').style.display='none';
    mapLoaded=true;
    document.getElementById('downloadBtn').disabled=false;
    setStatus('ok','\u2713 '+mapLabel);
    clearTimeout(fetchTimer);
    fetchTimer=setTimeout(fetchRoads,1200);
  }catch(err){
    setStatus('err','Error: '+err.message);
  }finally{
    isLoading=false;btn.disabled=false;btn.textContent='Search & Load Map';
  }
}

// ── SVG EXPORT HELPERS ───────────────────────────────────────────────────────
function bezierPts(x0,y0,x1,y1,x2,y2,x3,y3,n){
  var p=[];
  for(var i=0;i<=n;i++){var t=i/n,m=1-t;p.push({x:m*m*m*x0+3*m*m*t*x1+3*m*t*t*x2+t*t*t*x3,y:m*m*m*y0+3*m*m*t*y1+3*m*t*t*y2+t*t*t*y3});}
  return p;
}
function quadPts(x0,y0,x1,y1,x2,y2,n){
  var p=[];
  for(var i=0;i<=n;i++){var t=i/n,m=1-t;p.push({x:m*m*x0+2*m*t*x1+t*t*x2,y:m*m*y0+2*m*t*y1+t*t*y2});}
  return p;
}
function otPathToClipper(otPath,CSCALE){
  var polys=[],cur=null,cx=0,cy=0;
  otPath.commands.forEach(function(cmd){
    if(cmd.type==='M'){if(cur&&cur.length>2)polys.push(cur);cur=[];cx=cmd.x;cy=cmd.y;cur.push({X:Math.round(cx*CSCALE),Y:Math.round(cy*CSCALE)});}
    else if(cmd.type==='L'){cx=cmd.x;cy=cmd.y;if(cur)cur.push({X:Math.round(cx*CSCALE),Y:Math.round(cy*CSCALE)});}
    else if(cmd.type==='C'){var pp=bezierPts(cx,cy,cmd.x1,cmd.y1,cmd.x2,cmd.y2,cmd.x,cmd.y,10);cx=cmd.x;cy=cmd.y;if(cur)for(var i=1;i<pp.length;i++)cur.push({X:Math.round(pp[i].x*CSCALE),Y:Math.round(pp[i].y*CSCALE)});}
    else if(cmd.type==='Q'){var pp=quadPts(cx,cy,cmd.x1,cmd.y1,cmd.x,cmd.y,8);cx=cmd.x;cy=cmd.y;if(cur)for(var i=1;i<pp.length;i++)cur.push({X:Math.round(pp[i].x*CSCALE),Y:Math.round(pp[i].y*CSCALE)});}
    else if(cmd.type==='Z'){if(cur&&cur.length>2)polys.push(cur);cur=null;}
  });
  if(cur&&cur.length>2)polys.push(cur);
  return polys;
}
function clipperUnionToD(paths,CSCALE){
  if(!paths||!paths.length) return '';
  var c=new ClipperLib.Clipper();
  c.AddPaths(paths,ClipperLib.PolyType.ptSubject,true);
  var u=new ClipperLib.Paths();
  c.Execute(ClipperLib.ClipType.ctUnion,u,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return u.map(function(poly){
    return 'M '+poly.map(function(pt){return (pt.X/CSCALE).toFixed(3)+' '+(pt.Y/CSCALE).toFixed(3);}).join(' L ')+' Z';
  }).join(' ');
}
function pointInPoly(pt,poly){
  var x=pt[1],y=pt[0],inside=false; // x=lon, y=lat for [lat,lon] arrays
  for(var i=0,j=poly.length-1;i<poly.length;j=i++){
    var yi=poly[i][0],xi=poly[i][1],yj=poly[j][0],xj=poly[j][1];
    if((yi>y)!==(yj>y)&&x<(xj-xi)*(y-yi)/(yj-yi)+xi)inside=!inside;
  }
  return inside;
}

function circlePoly(cx,cy,r,n,CSCALE){
  var p=[];
  for(var i=0;i<n;i++){var a=2*Math.PI*i/n;p.push({X:Math.round((cx+r*Math.cos(a))*CSCALE),Y:Math.round((cy+r*Math.sin(a))*CSCALE)});}
  return p;
}

// ── SVG EXPORT ───────────────────────────────────────────────────────────────
async function exportSVG(){
  if(!lMap||!mapLoaded){alert('Load a map first.');return;}
  var btn=document.getElementById('downloadBtn');
  btn.disabled=true;btn.textContent='Preparing\u2026';
  try{
    var CSCALE=1e4;
    var unit=getUnit(),realDiam=(unit==='in')?(size*25.4):size;
    var rMm=realDiam/2;
    // Use actual Leaflet map pixel radius so SVG scale matches preview exactly
    var _lEl=document.getElementById('leafletMap');
    var leafletR=(_lEl&&_lEl.offsetWidth>0)?_lEl.offsetWidth/2:285;
    var sc=rMm/leafletR;
    var ctr=lMap.getCenter(),z=lMap.getZoom();
    var cpx=lMap.project([ctr.lat,ctr.lng],z);
    function ll2mm(la,lo){var p=lMap.project([la,lo],z);return{x:(p.x-cpx.x)*sc,y:(p.y-cpx.y)*sc};}

    var chY  =rMm*(61/150),chDx=rMm*(137/150);
    var ringIn=rMm*(133/150);
    var hoopY=-(172/150)*rMm;
    var hoopO=rMm*(19/150),hoopI=rMm*(11/150);
    var GAP=8;

    // Clip segment to circle
    function clipSeg(p1,p2){
      var dx=p2.x-p1.x,dy=p2.y-p1.y,a=dx*dx+dy*dy;
      if(a<1e-12)return null;
      var b=2*(p1.x*dx+p1.y*dy),c=p1.x*p1.x+p1.y*p1.y-rMm*rMm;
      var disc=b*b-4*a*c;if(disc<0)return null;
      var sq=Math.sqrt(disc),t0=Math.max(0,(-b-sq)/(2*a)),t1=Math.min(1,(-b+sq)/(2*a));
      if(t0>=t1-1e-9)return null;
      return{p1:{x:p1.x+t0*dx,y:p1.y+t0*dy},p2:{x:p1.x+t1*dx,y:p1.y+t1*dy}};
    }
    // Clip polyline to circle
    function clipPoly(pts){
      var out=[],cur=null,EPS=0.005;
      for(var i=0;i<pts.length-1;i++){
        var s=clipSeg(pts[i],pts[i+1]);
        if(!s){if(cur){out.push(cur);cur=null;}continue;}
        if(cur&&Math.abs(cur[cur.length-1].x-s.p1.x)<EPS&&Math.abs(cur[cur.length-1].y-s.p1.y)<EPS)cur.push(s.p2);
        else{if(cur)out.push(cur);cur=[s.p1,s.p2];}
      }
      if(cur)out.push(cur);return out;
    }
    // Clip to above chord (y <= chY)
    function clipChordAll(pts){
      var out=[],cur=null;
      for(var i=0;i<pts.length-1;i++){
        var p1=pts[i],p2=pts[i+1];
        var in1=(p1.y<=chY),in2=(p2.y<=chY);
        if(in1&&in2){if(!cur)cur=[p1];cur.push(p2);}
        else if(in1&&!in2){
          var t=(chY-p1.y)/(p2.y-p1.y);
          if(!cur)cur=[p1];
          cur.push({x:p1.x+t*(p2.x-p1.x),y:chY});
          if(cur.length>1)out.push(cur);cur=null;
        }else if(!in1&&in2){
          var t=(chY-p1.y)/(p2.y-p1.y);
          cur=[{x:p1.x+t*(p2.x-p1.x),y:chY},p2];
        }else{if(cur&&cur.length>1)out.push(cur);cur=null;}
      }
      if(cur&&cur.length>1)out.push(cur);
      return out;
    }

    // ── WATER HELPERS ───────────────────────────────────────────────────────
    // Detect closed OSM way (first node ≈ last node, as returned by Overpass)
    function isClosedGeom(geom){
      if(!geom||geom.length<4) return false;
      return Math.abs(geom[0].lat-geom[geom.length-1].lat)<0.00002&&
             Math.abs(geom[0].lon-geom[geom.length-1].lon)<0.00002;
    }
    // Clip a closed polygon (mm coords) to the ornament circle using ClipperLib intersection.
    // Returns array of ClipperLib paths (properly clipped, ready to add to waterPaths).
    function clipClosedPolyToCircle(mmPts){
      if(!mmPts||mmPts.length<3) return [];
      var polyPath=[mmPts.map(function(pt){return{X:Math.round(pt.x*CSCALE),Y:Math.round(pt.y*CSCALE)};})];
      var circPath=[circlePoly(0,0,rMm,128,CSCALE)];
      var c=new ClipperLib.Clipper();
      c.AddPaths(polyPath,ClipperLib.PolyType.ptSubject,true);
      c.AddPaths(circPath,ClipperLib.PolyType.ptClip,true);
      var res=new ClipperLib.Paths();
      c.Execute(ClipperLib.ClipType.ctIntersection,res,
                ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      return res;
    }

    // ── ROADS ───────────────────────────────────────────────────────────────
    btn.textContent='Outlining roads\u2026';
    var allowed=getAllowedHW();
    var allRoadPaths=new ClipperLib.Paths();
    ovElementsW.concat(ovElementsM,ovElementsD).forEach(function(el){
      if(!el.geometry||el.geometry.length<2) return;
      var t=el.tags||{};
      if(!t.highway||allowed.indexOf(t.highway)===-1) return;
      var hw=(WEIGHTS[t.highway]||1)*sc/2;
      var mmPts=el.geometry.map(function(p){return ll2mm(p.lat,p.lon);});
      clipPoly(mmPts).forEach(function(seg){
        clipChordAll(seg).forEach(function(upperSeg){
          if(upperSeg.length<2) return;
          var cPath=upperSeg.map(function(pt){return{X:Math.round(pt.x*CSCALE),Y:Math.round(pt.y*CSCALE)};});
          var co=new ClipperLib.ClipperOffset();co.ArcTolerance=0.12*CSCALE;
          co.AddPath(cPath,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etOpenRound);
          var off=new ClipperLib.Paths();co.Execute(off,hw*CSCALE);
          for(var i=0;i<off.length;i++)allRoadPaths.push(off[i]);
        });
      });
    });
    btn.textContent='Merging roads\u2026';
    var allRoadD=clipperUnionToD(allRoadPaths,CSCALE);

    // ── WATER (FIXED) ────────────────────────────────────────────────────────
    // Fix 1: multipolygon water relations → stitch outer ways → filled polygon
    // Fix 2: closed natural=water ways → filled polygon (not offset blob)
    // Fix 3: open ways (rivers) → keep offset approach
    // Fix 4: coastlines → render as thick line stroke
    btn.textContent='Processing water\u2026';
    var waterPaths=new ClipperLib.Paths();

    // 1. Relations: stitch outer members into complete water polygons
    ovElementsW.concat(ovElementsM,ovElementsD).forEach(function(el){
      if(el.type!=='relation') return;
      var t=el.tags||{};
      if(t.natural!=='water'&&!t.waterway) return;
      var outerMm=[];
      (el.members||[]).forEach(function(m){
        if(!m.geometry||m.geometry.length<2) return;
        if(m.role==='inner') return; // skip holes for now
        outerMm.push(m.geometry.map(function(p){return ll2mm(p.lat,p.lon);}));
      });
      if(!outerMm.length) return;
      stitchMmPaths(outerMm).forEach(function(chain){
        if(chain.length<3) return;
        var res=clipClosedPolyToCircle(chain);
        for(var i=0;i<res.length;i++) waterPaths.push(res[i]);
      });
    });

    // 2. Individual ways
    ovElementsW.concat(ovElementsM,ovElementsD).forEach(function(el){
      if(el.type==='relation') return;
      if(!el.geometry||el.geometry.length<2) return;
      var t=el.tags||{};
      var mmPts=el.geometry.map(function(p){return ll2mm(p.lat,p.lon);});

      if(t.natural==='water'){
        if(isClosedGeom(el.geometry)){
          // Closed polygon lake/pond → proper filled polygon clipped to circle
          var res=clipClosedPolyToCircle(mmPts);
          for(var i=0;i<res.length;i++) waterPaths.push(res[i]);
        }
        // Unclosed ways are outer members of relations (handled above)
      } else if(t.waterway==='river'||t.waterway==='canal'){
        // Rivers: thick stroke
        clipPoly(mmPts).forEach(function(seg){
          if(seg.length<2) return;
          var cPath=seg.map(function(pt){return{X:Math.round(pt.x*CSCALE),Y:Math.round(pt.y*CSCALE)};});
          var co=new ClipperLib.ClipperOffset();co.ArcTolerance=0.12*CSCALE;
          co.AddPath(cPath,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etOpenRound);
          var off=new ClipperLib.Paths();co.Execute(off,2*sc*CSCALE);
          for(var i=0;i<off.length;i++) waterPaths.push(off[i]);
        });
      } else if(t.natural==='coastline'){
        // Coastlines: medium-width stroke representing the shore
        clipPoly(mmPts).forEach(function(seg){
          if(seg.length<2) return;
          var cPath=seg.map(function(pt){return{X:Math.round(pt.x*CSCALE),Y:Math.round(pt.y*CSCALE)};});
          var co=new ClipperLib.ClipperOffset();co.ArcTolerance=0.12*CSCALE;
          co.AddPath(cPath,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etOpenRound);
          var off=new ClipperLib.Paths();co.Execute(off,1.5*sc*CSCALE);
          for(var i=0;i<off.length;i++) waterPaths.push(off[i]);
        });
      }
    });

    // ── COASTLINE → OCEAN FILL for export ───────────────────────────────
    var exportCoastSegs=[];
    ovElementsW.concat(ovElementsM,ovElementsD).forEach(function(el){
      if(el.type==='relation'||!el.geometry||el.geometry.length<2) return;
      var t=el.tags||{};
      if(t.natural==='coastline'){
        exportCoastSegs.push(el.geometry.map(function(p){return[p.lat,p.lon];}));
      }
    });
    if(exportCoastSegs.length&&fetchedBoundsW){
      var fb=fetchedBoundsW;
      var clippedExport=[];
      stitchCoastlines(exportCoastSegs).forEach(function(chain){
        clipToBox(chain,fb.N,fb.S,fb.W,fb.E).forEach(function(c){clippedExport.push(c);});
      });
      var eCenterLL=mapCenter?[mapCenter.lat,mapCenter.lon]:[0,0];
      makeOceanPolygons(clippedExport,fb).forEach(function(poly){
        // Only add WATER polygons (not land) to waterPaths
        if(mapCenter&&pointInPoly(eCenterLL,poly)) return;
        var mmPts=poly.map(function(p){return ll2mm(p[0],p[1]);});
        var res=clipClosedPolyToCircle(mmPts);
        for(var i=0;i<res.length;i++) waterPaths.push(res[i]);
      });
    }
    // ── COASTLINE → OCEAN FILL (same CW-closure logic as preview) ──────
    // Collect coastline lat/lon coords, stitch, clip to fetchedBoundsW,
    // compute CW-closure ocean polygons, convert to mm, clip to circle.
    var waterD=clipperUnionToD(waterPaths,CSCALE);

    // ── TEXT ─────────────────────────────────────────────────────────────────
    btn.textContent='Loading fonts\u2026';
    var l1t=(document.getElementById('line1').value||'Where We Became a Family').toUpperCase();
    var l2t=document.getElementById('line2').value||"The Bassetts'";
    var l3t=document.getElementById('line3').value||'2002\u20132025';
    var sp12v=parseInt((document.getElementById('sp12')||{value:0}).value)||0;
    var sp23v=parseInt((document.getElementById('sp23')||{value:0}).value)||0;
    var fs1=arcSz[1]*rMm/150,fs2=arcSz[2]*rMm/150,fs3=arcSz[3]*rMm/150;
    var ty1=76*rMm/150,ty2=ty1+(25+sp12v)*rMm/150,ty3=ty2+(22+sp23v)*rMm/150;
    var ls1=0.27,ls3=0.22;
    var l2fDropdown=(document.getElementById('line2Font')||{value:'Dancing Script'}).value;
    var FURL2={
      'Dancing Script':'https://cdn.jsdelivr.net/npm/@fontsource/dancing-script/files/dancing-script-latin-700-normal.woff',
      'Great Vibes':'https://cdn.jsdelivr.net/npm/@fontsource/great-vibes/files/great-vibes-latin-400-normal.woff',
      'Parisienne':'https://cdn.jsdelivr.net/npm/@fontsource/parisienne/files/parisienne-latin-400-normal.woff',
      'Sacramento':'https://cdn.jsdelivr.net/npm/@fontsource/sacramento/files/sacramento-latin-400-normal.woff',
      'Pinyon Script':'https://cdn.jsdelivr.net/npm/@fontsource/pinyon-script/files/pinyon-script-latin-400-normal.woff',
      'Cormorant Garamond':'https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond/files/cormorant-garamond-latin-600-normal.woff',
      'Cinzel':'https://cdn.jsdelivr.net/npm/@fontsource/cinzel/files/cinzel-latin-600-normal.woff',
      'Alex Brush':'https://cdn.jsdelivr.net/npm/@fontsource/alex-brush/files/alex-brush-latin-400-normal.woff'
    };
    var f1url='https://cdn.jsdelivr.net/npm/@fontsource/cinzel/files/cinzel-latin-600-normal.woff';
    var f2url=FURL2[l2fDropdown]||FURL2['Dancing Script'];

    function t2pClipper(font,text,cx,cy,sz,ls){
      if(!font||!text.trim()) return '';
      try{
        var opts={letterSpacing:ls||0};
        var pp=font.getPaths(text,0,cy,sz,opts);
        var bx1=Infinity,bx2=-Infinity;
        pp.forEach(function(p){try{var b=p.getBoundingBox();if(isFinite(b.x1)){bx1=Math.min(bx1,b.x1);bx2=Math.max(bx2,b.x2);}}catch(e){}});
        if(!isFinite(bx1)||bx1>=bx2){bx1=0;bx2=font.getAdvanceWidth(text,sz,opts);}
        var startX=cx-(bx1+bx2)/2;
        var otPath=font.getPath(text,startX,cy,sz,opts);
        var polys=otPathToClipper(otPath,CSCALE);
        if(!polys.length) return '';
        return clipperUnionToD(polys,CSCALE);
      }catch(e){console.warn('t2p error:',e);return '';}
    }

    var tp1='',tp2='',tp3='',textAsPath=false;
    if(typeof opentype!=='undefined'){
      var FC={};
      async function lF(u){if(FC[u])return FC[u];var ab=await fetch(u).then(function(r){return r.arrayBuffer();});return(FC[u]=opentype.parse(ab));}
      try{
        btn.textContent='Loading fonts (1/3)\u2026';var font1=await lF(f1url);
        btn.textContent='Loading fonts (2/3)\u2026';var font2=await lF(f2url);
        btn.textContent='Loading fonts (3/3)\u2026';var font3=await lF('https://cdn.jsdelivr.net/npm/@fontsource/cinzel/files/cinzel-latin-600-normal.woff');
        btn.textContent='Merging text glyphs\u2026';
        tp1=t2pClipper(font1,l1t,0,ty1,fs1,ls1);
        tp2=t2pClipper(font2,l2t,0,ty2,fs2,0);
        tp3=t2pClipper(font3,l3t,0,ty3,fs3,ls3);
        textAsPath=!!(tp1||tp2||tp3);
      }catch(fe){console.warn('Font error:',fe);}
    }

    // ── HOOP & CUT GEOMETRY ─────────────────────────────────────────────────
    var exportHoopY=hoopY+hoopO*0.35;
    var mainCircPoly=[circlePoly(0,0,rMm,128,CSCALE)];
    var hoopOuterPoly=[circlePoly(0,exportHoopY,hoopO,48,CSCALE)];
    var hoopInnerPoly=[circlePoly(0,exportHoopY,hoopI,36,CSCALE)];
    var cH=new ClipperLib.Clipper();
    cH.AddPaths(hoopOuterPoly,ClipperLib.PolyType.ptSubject,true);
    cH.AddPaths(hoopInnerPoly,ClipperLib.PolyType.ptClip,true);
    var hoopRing=new ClipperLib.Paths();
    cH.Execute(ClipperLib.ClipType.ctDifference,hoopRing,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
    var cL=new ClipperLib.Clipper();
    cL.AddPaths(mainCircPoly,ClipperLib.PolyType.ptSubject,true);
    cL.AddPaths(hoopRing,ClipperLib.PolyType.ptClip,true);
    var l1CutPaths=new ClipperLib.Paths();
    cL.Execute(ClipperLib.ClipType.ctUnion,l1CutPaths,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
    var l1CutD=l1CutPaths.map(function(poly){
      return 'M '+poly.map(function(pt){return (pt.X/CSCALE).toFixed(3)+' '+(pt.Y/CSCALE).toFixed(3);}).join(' L ')+' Z';
    }).join(' ');

    // ── 3-LAYER MODE: compute land shape (circle minus water) ────────────
    var l3tog=document.getElementById('layer3Toggle');
    var is3Layer=l3tog&&l3tog.checked;
    var landCutD='';
    if(is3Layer&&waterPaths.length){
      var cL3=new ClipperLib.Clipper();
      cL3.AddPaths(mainCircPoly,ClipperLib.PolyType.ptSubject,true);
      cL3.AddPaths(waterPaths,ClipperLib.PolyType.ptClip,true);
      var landPaths=new ClipperLib.Paths();
      cL3.Execute(ClipperLib.ClipType.ctDifference,landPaths,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      // Add support ring to land layer: matches Layer 3's ring thickness
      // exactly, so the frame ring always has material underneath it even
      // where water was cut away at the edges.
      var supportOuter=[circlePoly(0,0,rMm,128,CSCALE)];
      var supportInner=[circlePoly(0,0,ringIn,128,CSCALE)];
      var cRing=new ClipperLib.Clipper();
      cRing.AddPaths(supportOuter,ClipperLib.PolyType.ptSubject,true);
      cRing.AddPaths(supportInner,ClipperLib.PolyType.ptClip,true);
      var ringPaths=new ClipperLib.Paths();
      cRing.Execute(ClipperLib.ClipType.ctDifference,ringPaths,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      var cUnion=new ClipperLib.Clipper();
      cUnion.AddPaths(landPaths,ClipperLib.PolyType.ptSubject,true);
      cUnion.AddPaths(ringPaths,ClipperLib.PolyType.ptClip,true);
      var landWithRing=new ClipperLib.Paths();
      cUnion.Execute(ClipperLib.ClipType.ctUnion,landWithRing,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      landPaths=landWithRing;
      landCutD=landPaths.map(function(poly){
        return 'M '+poly.map(function(pt){return (pt.X/CSCALE).toFixed(3)+' '+(pt.Y/CSCALE).toFixed(3);}).join(' L ')+' Z';
      }).join(' ');
    }else if(is3Layer){
      // No water data: land = full circle
      var cp=circlePoly(0,0,rMm,128,CSCALE);
      landCutD='M '+cp.map(function(pt){return (pt.X/CSCALE).toFixed(3)+' '+(pt.Y/CSCALE).toFixed(3);}).join(' L ')+' Z';
    }

    var pinPt=mapCenter?ll2mm(mapCenter.lat,mapCenter.lon):{x:0,y:0};
    var pinInCircle=Math.sqrt(pinPt.x*pinPt.x+pinPt.y*pinPt.y)<rMm*0.98;
    var heartD='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';

    var p2x=2*rMm+GAP;
    var frameX=is3Layer?(4*rMm+2*GAP):p2x; // frame position: 3rd slot or 2nd
    var R=rMm,Ri=ringIn;
    var arcChDx=Math.sqrt(Math.max(0,Ri*Ri-chY*chY));
    // Merged Layer 2: outer circle + D-shape inner cutout.
    // Inner cutout = top arc of inner circle (above chord) + chord line.
    // Bottom portion (text area) is solid — ring and arc are one piece.
    var mergedD='M '+R.toFixed(3)+' 0 A '+R.toFixed(3)+' '+R.toFixed(3)+' 0 1 0 '+(-R).toFixed(3)+' 0 A '+R.toFixed(3)+' '+R.toFixed(3)+' 0 1 0 '+R.toFixed(3)+' 0 Z'+
      ' M '+arcChDx.toFixed(3)+' '+chY.toFixed(3)+' A '+Ri.toFixed(3)+' '+Ri.toFixed(3)+' 0 1 0 '+(-arcChDx).toFixed(3)+' '+chY.toFixed(3)+' L '+arcChDx.toFixed(3)+' '+chY.toFixed(3)+' Z';

        // ── BUILD SVG ────────────────────────────────────────────────────────────
    btn.textContent='Building SVG\u2026';
    var vbL=-(rMm+4),vbT=exportHoopY-hoopO-4,vbR=(is3Layer?frameX:p2x)+rMm+4,vbB=rMm+28;
    var vbW=vbR-vbL,vbH=vbB-vbT;
    var P=[];
    P.push('<?xml version="1.0" encoding="UTF-8"?>');
    P.push('<!-- Map Ornament | #000000=engrave | #ff0000=cut | #7ec8e3=light engrave (water) -->');
    P.push('<svg xmlns="http://www.w3.org/2000/svg" width="'+vbW.toFixed(2)+'mm" height="'+vbH.toFixed(2)+'mm" viewBox="'+vbL.toFixed(2)+' '+vbT.toFixed(2)+' '+vbW.toFixed(2)+' '+vbH.toFixed(2)+'">');
    if(is3Layer){
      // ── 3-LAYER: L1 = water backing (cut only, no engravings) ─────────
      P.push('<g id="L1-water">');
      P.push('  <text x="0" y="'+(rMm+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(rMm*0.045).toFixed(2)+'" fill="#888888">Layer 1 (Water): <tspan fill="#ff0000">Red=CUT</tspan></text>');
      if(l1CutD)
        P.push('  <path id="L1-cut" d="'+l1CutD+'" fill="none" stroke="#ff0000" stroke-width="0.1" fill-rule="evenodd"/>');
      P.push('</g>');

      // ── 3-LAYER: L2 = land cutout (circle minus water) + roads ────────
      P.push('<g id="L2-land" transform="translate('+p2x.toFixed(2)+',0)">');
      P.push('  <text x="0" y="'+(rMm+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(rMm*0.045).toFixed(2)+'" fill="#888888">Layer 2 (Land): <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave</tspan></text>');
      if(allRoadD.trim())
        P.push('  <path id="roads" fill="#000000" fill-rule="evenodd" stroke="none" d="'+allRoadD.trim()+'"/>');
      if(landCutD)
        P.push('  <path id="L2-land-cut" d="'+landCutD+'" fill="none" stroke="#ff0000" stroke-width="0.1" fill-rule="evenodd"/>');
      P.push('</g>');
    }else{
      // ── 2-LAYER: L1 = everything (roads + water + cut) ────────────────
      P.push('<g id="L1">');
      P.push('  <text x="0" y="'+(rMm+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(rMm*0.045).toFixed(2)+'" fill="#888888">Layer 1: <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#4a9fc4">Blue=Light engrave (water)</tspan></text>');
      if(allRoadD.trim())
        P.push('  <path id="roads" fill="#000000" fill-rule="evenodd" stroke="none" d="'+allRoadD.trim()+'"/>');
      if(waterD.trim())
        P.push('  <path id="water" fill="#7ec8e3" fill-rule="evenodd" stroke="none" d="'+waterD.trim()+'"/>');
      if(l1CutD)
        P.push('  <path id="L1-cut" d="'+l1CutD+'" fill="none" stroke="#ff0000" stroke-width="0.1" fill-rule="evenodd"/>');
      P.push('</g>');
    }
    { // Frame (ring+arc) — always included
      P.push('<g id="'+(is3Layer?'L3':'L2')+'" transform="translate('+(is3Layer?frameX:p2x).toFixed(2)+',0)">');
      P.push('  <text x="0" y="'+(rMm+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(rMm*0.045).toFixed(2)+'" fill="#888888">'+(is3Layer?'Layer 3':'Layer 2')+': <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave/Score</tspan></text>');
      P.push('  <path id="L2-cut" d="'+mergedD+'" fill="none" stroke="#ff0000" stroke-width="0.1" fill-rule="evenodd"/>');
      P.push('  <line id="L2-score" x1="'+(-arcChDx).toFixed(3)+'" y1="'+chY.toFixed(3)+'" x2="'+arcChDx.toFixed(3)+'" y2="'+chY.toFixed(3)+'" stroke="#000000" stroke-width="0.1"/>');
      if(textAsPath){
        if(tp1) P.push('  <path id="text1" d="'+tp1+'" fill="#000000" fill-rule="evenodd"/>');
        if(tp2) P.push('  <path id="text2" d="'+tp2+'" fill="#000000" fill-rule="evenodd"/>');
        if(tp3) P.push('  <path id="text3" d="'+tp3+'" fill="#000000" fill-rule="evenodd"/>');
      }else{
        P.push('  <!-- Fonts unavailable \u2013 convert text to outlines in Illustrator -->');
        P.push('  <text x="0" y="'+ty1.toFixed(2)+'" text-anchor="middle" font-family="Cinzel,serif" font-size="'+fs1.toFixed(3)+'mm">'+xmlEsc(l1t)+'</text>');
        P.push('  <text x="0" y="'+ty2.toFixed(2)+'" text-anchor="middle" font-family="'+xmlEsc(l2fDropdown)+',cursive" font-size="'+fs2.toFixed(3)+'mm">'+xmlEsc(l2t)+'</text>');
        P.push('  <text x="0" y="'+ty3.toFixed(2)+'" text-anchor="middle" font-family="Cinzel,serif" font-size="'+fs3.toFixed(3)+'mm">'+xmlEsc(l3t)+'</text>');
      }
      P.push('</g>');
    }
    // Heart pin — standalone in the gap between Layer 1 and Layer 2
    if(mapCenter&&pinInCircle&&pinPt.y<chY){
      var pinSizeMm=rMm*0.18,pinSc=pinSizeMm/20;
      var gapX=rMm+GAP/2; // horizontal center of the gap
      var gapY=-(rMm*0.65); // upper area of the gap
      P.push('<g id="heart-pin" transform="translate('+gapX.toFixed(3)+','+gapY.toFixed(3)+') scale('+pinSc.toFixed(4)+') translate(-12,-12)">');
      P.push('  <path d="'+heartD+'" fill="#cc2200" stroke="none"/>');
      P.push('</g>');
    }
    P.push('</svg>');

    var svg=P.join('\n');
    var blob=new Blob([svg],{type:'image/svg+xml'});
    var url=URL.createObjectURL(blob);
    var a=document.createElement('a');a.href=url;a.download='map-ornament.svg';a.click();
    setTimeout(function(){URL.revokeObjectURL(url);},1000);
    setStatus('ok','\u2713 '+mapLabel);
  }catch(err){
    console.error('Export error:',err);
    setStatus('err','Export error: '+err.message);
  }finally{
    btn.disabled=false;btn.textContent='\u2193 Download SVG';
  }
}

// ── CONTROLS ─────────────────────────────────────────────────────────────────
document.getElementById('zoomSlider').addEventListener('input',function(){
  zoom=parseFloat(this.value);
  zoomValEl.textContent=fmtZoom(zoom);
  if(lMap) lMap.setZoom(zoom,{animate:true});
});
document.getElementById('sizeDown').onclick=function(){
  var el=document.getElementById('sizeVal'),u=getUnit(),step=u==='in'?0.5:5;
  size=Math.max(sizeMin,+(((parseFloat(el.value||el.textContent)||4)-step).toFixed(3)));
  if(el.tagName==='INPUT')el.value=size;else el.textContent=size;updateDimHint();
};
document.getElementById('sizeUp').onclick=function(){
  var el=document.getElementById('sizeVal'),u=getUnit(),step=u==='in'?0.5:5;
  size=Math.min(sizeMax,+(((parseFloat(el.value||el.textContent)||4)+step).toFixed(3)));
  if(el.tagName==='INPUT')el.value=size;else el.textContent=size;updateDimHint();
};
document.querySelectorAll('.seg .sb').forEach(function(btn){
  btn.addEventListener('click',function(){
    var g=btn.dataset.group;if(!g)return;
    document.querySelectorAll('.sb[data-group="'+g+'"]').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    if(g==='detail'){
      detail=btn.dataset.val;
      if(lMap&&roadLayer)renderRoads(); // instant re-filter from cache
      if(mapLoaded){clearTimeout(fetchTimer);fetchTimer=setTimeout(fetchRoads,50);}
    }
  });
});
document.querySelectorAll('[data-group="unit"]').forEach(function(btn){
  btn.addEventListener('click',function(){
    var prevUnit=getUnit();
    document.querySelectorAll('[data-group="unit"]').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    var nextUnit=getUnit();
    if(prevUnit===nextUnit)return;
    var el=document.getElementById('sizeVal');
    var v=parseFloat(el?(el.value||el.textContent):'4')||4;
    if(prevUnit==='in'&&nextUnit==='mm')v=Math.round(v*25.4*10)/10;
    else if(prevUnit==='mm'&&nextUnit==='in')v=Math.round(v/25.4*100)/100;
    size=v;sizeMin=nextUnit==='in'?1:25;sizeMax=nextUnit==='in'?12:300;
    if(el){if(el.tagName==='INPUT')el.value=v;else el.textContent=v;}
    updateDimHint();
  });
});
document.querySelectorAll('.pin-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    document.querySelectorAll('.pin-btn').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    if(heartMarker&&mapCenter) heartMarker.setIcon(buildPinIcon(btn.dataset.pin));
  });
});
document.getElementById('fetchBtn').addEventListener('click',loadMap);
document.getElementById('addressInput').addEventListener('keydown',function(e){if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();loadMap();}});

var SZ_MIN=[0,5,10,5],SZ_MAX=[0,18,60,20],SZ_STEP=[0,0.5,1,0.5];
document.querySelectorAll('.arc-sz-btn').forEach(function(b){
  b.addEventListener('click',function(){
    var line=parseInt(this.dataset.szline),dir=parseInt(this.dataset.dir);
    arcSz[line]=Math.max(SZ_MIN[line],Math.min(SZ_MAX[line],arcSz[line]+SZ_STEP[line]*dir));
    var valEl=document.getElementById('sz'+line+'val');
    if(valEl)valEl.textContent=arcSz[line].toFixed(arcSz[line]%1?1:0);
    updatePreview();
  });
});
var l2f=document.getElementById('line2Font');
if(l2f)l2f.addEventListener('change',updatePreview);
['sp12','sp23'].forEach(function(id){var el=document.getElementById(id);if(el)el.addEventListener('input',updatePreview);});
document.getElementById('downloadBtn').addEventListener('click',exportSVG);

// ── PREVIEW ───────────────────────────────────────────────────────────────────
function updatePreview(){
  var l1=document.getElementById('line1').value||'Where We Became a Family';
  var l2=document.getElementById('line2').value||"The Bassetts'";
  var l3=document.getElementById('line3').value||'2002\u20132025';
  var f2sel=document.getElementById('line2Font');
  var f2font=f2sel?f2sel.value:'Dancing Script';
  var fs1=arcSz[1],fs2=arcSz[2],fs3=arcSz[3];
  var sp12=parseInt((document.getElementById('sp12')||{value:0}).value)||0;
  var sp23=parseInt((document.getElementById('sp23')||{value:0}).value)||0;
  var ty1=276,ty2=301+sp12,ty3=323+sp12+sp23;
  function set(id,txt,font,fs,ty,ls){
    var e=document.getElementById(id);if(!e)return;
    e.textContent=txt;
    if(font)e.setAttribute('font-family',font);
    if(fs)e.setAttribute('font-size',fs);
    if(ty)e.setAttribute('y',ty);
    if(ls!=null)e.setAttribute('letter-spacing',ls);
  }
  set('prevLine1',l1.toUpperCase(),'Cinzel,serif',fs1,ty1,(fs1*0.2).toFixed(1));
  set('prevLine2',l2,f2font+',cursive',fs2,ty2,0);
  set('prevLine3',l3,'Cinzel,serif',fs3,ty3,(fs3*0.2).toFixed(1));
}
['line1','line2','line3'].forEach(function(id){var e=document.getElementById(id);if(e)e.addEventListener('input',updatePreview);});

// ── RESET ─────────────────────────────────────────────────────────────────────
document.getElementById('resetBtn').addEventListener('click',function(){
  document.getElementById('addressInput').value='';
  setStatus('','No map loaded');
  ['line1','line2','line3'].forEach(function(id){document.getElementById(id).value='';});
  zoom=14;zoomValEl.textContent='14';document.getElementById('zoomSlider').value='14';
  size=4;updateDimHint();detail='med';
  document.querySelectorAll('.pin-btn').forEach(function(b,i){b.classList.toggle('on',i===0);});
  document.querySelectorAll('.sb[data-group="detail"]').forEach(function(b){b.classList.toggle('on',b.dataset.val==='med');});
  document.getElementById('layer3Toggle').checked=false;
  if(heartMarker){heartMarker.remove();heartMarker=null;}
  if(waterLayer)waterLayer.clearLayers();
  if(roadLayer)roadLayer.clearLayers();
  if(lMap)lMap.setView([20,0],2);
  ovElementsW=[];ovElementsM=[];ovElementsD=[];
  fetchedBoundsW=null;fetchedBoundsM=null;fetchedBoundsD=null;
  mapCenter=null;mapLoaded=false;
  document.getElementById('noMapPlaceholder').style.display='';
  document.getElementById('downloadBtn').disabled=true;
  updatePreview();
});

// ── INIT ─────────────────────────────────────────────────────────────────────
window._appLoadMap=loadMap;
window.onerror=function(msg,src,line,col,err){
  var el=document.getElementById('mapStatus');
  if(el)el.innerHTML='<span style="color:#ff7c7c;font-weight:700">JS Error: '+msg+' (line '+line+')</span>';
  return false;
};
try{initLeaflet();}
catch(e){
  var el=document.getElementById('mapStatus');
  if(el)el.innerHTML='<span style="color:#ff7c7c;font-weight:700">Map init error: '+e.message+'</span>';
}
updateDimHint();
updatePreview();

})();

// ── Analytics tracking ───────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  // Track map load button clicks
  const loadMapBtn = document.querySelector('.mapornament-load-map');
  const addressInput = document.getElementById('addressInput');
  
  loadMapBtn.addEventListener('click', function () {
    const address = addressInput.value.trim();
    if (address !== '') {
      gtag('event', 'mapornament_load_map', {
        event_category: 'generator',
        generator_type: 'mapornament',
        event_label: 'load_map_button_clicked',
        address: address
      });
    }
  });
  
  // Track SVG downloads
  const downloadBtn = document.querySelector('.mapornament-download');
  downloadBtn.addEventListener('click', function () {
    gtag('event', 'mapornament_download_svg', {
      event_category: 'generator',
      generator_type: 'mapornament',
      event_label: 'download_svg_button_clicked',
      address: addressInput.value.trim()
    });
  });
});